import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Spinner } from 'reactstrap'
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { Button, Card, CardBody, CardFooter, Col, DropdownMenu, DropdownToggle, Nav, NavLink, Row, UncontrolledButtonDropdown, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, ButtonGroup } from "reactstrap";
import Tippy from '@tippyjs/react';
import Details from "./Details";
import Chat from "./Chat";
import RequestList from "./RequestList";
import PageHeading from "Layout/AppMain/PageHeading";
import { ReactComponent as Arrow } from "../../../../../assets/utils/images/svgs/Arrow 3.svg";
import { ReactComponent as EditPen } from "../../../../../assets/utils/images/svgs/editPen.svg";
import { ReactComponent as GrrayCircle } from "../../../../../assets/utils/images/svgs/GrrayCircle.svg";
import { ReactComponent as AlarmClock } from "../../../../../assets/utils/images/svgs/AlarmClock.svg";
import { ReactComponent as Home } from "../../../../../assets/utils/images/svgs/home.svg";
import { ReactComponent as Save } from "../../../../../assets/utils/images/svgs/save_two.svg";
import { ReactComponent as Small_Arrow } from "../../../../../assets/utils/images/svgs/Small_Arrow.svg";
import { ReactComponent as Rood } from "../../../../../assets/utils/images/svgs/Rood.svg";
import { ReactComponent as Groen } from "../../../../../assets/utils/images/svgs/Groen.svg";
import { ReactComponent as Paars } from "../../../../../assets/utils/images/svgs/Paars.svg";
import { ReactComponent as Oranje } from "../../../../../assets/utils/images/svgs/Oranje.svg";
import { ReactComponent as Grijs } from "../../../../../assets/utils/images/svgs/Grijs.svg";
import { ReactComponent as ShowSchool } from "../../../../../assets/utils/images/svgs/ShowSchool.svg";
import { ReactComponent as RaedSchool } from "../../../../../assets/utils/images/svgs/RaedSchool.svg";
import { ReactComponent as Teachershow } from "../../../../../assets/utils/images/svgs/Teacher-show.svg";
import { ReactComponent as Teacher } from "../../../../../assets/utils/images/svgs/Teacher.svg";
import { ReactComponent as TeacherRead } from "../../../../../assets/utils/images/svgs/teacher-read.svg";
import { ReactComponent as LogIcon } from "../../../../../assets/utils/images/svgs/log.svg";
import UpdateRequestModel from "../../../../../Components/Modal/UpdateRequestModel"
import DropdownList from "react-widgets/DropdownList";
import { ErrorMessage, Formik, Field } from "formik";
import { RxCross1 } from "react-icons/rx";
import * as Yup from "yup";
import UpdateRequestInBulkModel from "Components/Modal/UpdateRequestInBulkModel";
import InformationModel from "Components/Modal/InformationModal";
import VerzoekenService from "Api/Verzoeken";
import PlanscreenService from "Api/Verzoeken/Planscreen";
import { getPlanscreenEndpoint } from "helperFunctions/planscreenEndpoint";
import {
    getCachedFiltersForContract,
    setCachedFiltersForContract,
} from "helperFunctions/planscreenFiltersCache";
import { useQueryClient } from "@tanstack/react-query";
import Logs from "./Logs";
import Loader from "react-loaders";
import DeleteModal from "./TableModals/DeleteModal";
import MentionInput from '../../../../../Components/MentionInput/index.js'
import TextLimit from "Api/TextLimit";
import CommonService from "Api/Common";
import useSWR from "swr";
import useSWRInfinite from "swr/infinite";
import { useDeleteDayPart, useGetArchivedMessages, useGetLongContractAdminList, useGetLongContractDetails, useMelderReminder, useRemoveUser, useSaveComment, useSaveLongContract, useSaveShiftData, useUpdateDayPartStatus, useUpdateLongContract, useUpdateWtf } from "Api/Coordinator/Verzoeken/Partial";
import { useNavBlock } from "helperFunctions/GuardNavigation";



const Default = (props) => {
    const params = useParams();
    const [showModal, setShowModal] = useState(false);
    const [value, setValue] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [isLongContractOpen, setIsLongContractOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [isEmpty, setIsEmpty] = useState(false);
    const [comments, setComments] = useState([]);
    const substitutionId = params.id || '';
    const [isChecked, setIsChecked] = useState(false);
    let navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [homeDropdownShow, setHomeDropdownShow] = useState(false);
    const [userDropdownShow, setUserDropdownShow] = useState(false);
    const [adminList, setAdminList] = useState([]);
    const [type, setType] = useState('');
    const [longContractId, setLongContractId] = useState(0);
    const [menuShow, setMenuShow] = useState(false);
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
    const [userMarking, setUserMarking] = useState("");
    const [editRequestIsOpen, setEditRequestIsOpen] = useState(false);
    const [bulkRequestIsOpen, setBulkRequestIsOpen] = useState(false);
    const [bulkShiftData, setBulkShiftData] = useState([]);
    const [checkedList, setCheckedList] = useState([]);
    const [statusCount, setStatusCount] = useState(0);
    const [changedStatusIds, setChangedStatusIds] = useState([]);
    const [showWTFValue, setShowWtfValue] = useState(false);
    const [deleteModalData, setDeleteModalData] = useState({ type: '' });
    const pageSize = 150;
    const [isPaginating, setIsPaginating] = useState(false);
    const observer = useRef();
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [showSweetAlert, setShowSweetAlert] = useState(false);
    const [emailSmsRecipients, setEmailAndSmsRecipients] = useState([]);
    const firstLoad = useRef(true);
    const prevRecipientsRef = useRef({});
    const [recipientsLists, setRecipientsLists] = useState({});
    const [schoolMarking, setSchoolMarking] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);
    const [selectedDate, setSelectedDate] = useState("");
    const [dayPartId, setDayPartId] = useState(null);
    const [isMelderDatePicker, setIsMelderDatePicker] = useState(false);
    const {
        isInformationModalOpen, setIsInformationModalOpen, guardedNavigate } = useNavBlock();
    const { trigger: updateDayPartStatus } = useUpdateDayPartStatus();
    const { trigger: updateWtfMutation } = useUpdateWtf();
    const { trigger: saveMessage } = useSaveComment(substitutionId);
    const { trigger } = useSaveShiftData();
    const { trigger: saveLongContractMutation } = useSaveLongContract();
    const { trigger: updateLongContractMutation } = useUpdateLongContract();
    const { trigger: getLongContractDetailsMutation } = useGetLongContractDetails();
    const { trigger: melderReminderMutation } = useMelderReminder();
    const { trigger: removeUserMutation } = useRemoveUser();


    const {
        data: longContractDetails,
    } = useGetLongContractDetails(longContractId);

    const getLongContractDetails = (id) => {
        setLongContractId(id);
    };


    const {
        data: longContractResponse,
        isLoading: isLongContractLoading,
    } = useGetLongContractAdminList(
        isLongContractOpen ? substitutionId : null
    );

    useEffect(() => {
        if (longContractResponse?.status) {
            const list = longContractResponse.data.map(item => ({
                ...item,
                name: `${item.vLastName}, ${item.vMiddleName} ${item.vFirstName}`,
            }));

            setAdminList(list);
        }
    }, [longContractResponse]);

    const requestParams = useMemo(() => {
        if (!substitutionId || type === null) return null;

        return {
            iSubstitutionId: substitutionId,
            type,
        };
    }, [substitutionId, type]);

    const {
        data: ArchivedResponse,
        mutate: mutateArchivedMessages,
    } = useGetArchivedMessages(substitutionId, type);


    useEffect(() => {
        if (ArchivedResponse?.data) {
            setComments(ArchivedResponse.data);
        }
    }, [ArchivedResponse]);

    const getArchivedMessages = (newType) => {
        setType(newType);
    };

    const moment = require('moment');
    const prefetchedDayIdsRef = useRef(new Set());
    const prefetchedCommunityIdsRef = useRef(new Set());
    const queryClient = useQueryClient();

    const [bulkFormData, setBulkFormData] = useState({
        start: '',
        end: '',
        substitutor: '',
        current_state: '',
        newDayType: '',
        newWtfType: '',
        newStatus: '',
        newInform: 'yes',
        items: [],
        wtfItems: [],
    });
    const [formDataState, setFormDataState] = useState({
        ma: '',
        di: '',
        wo: '',
        doo: '',
        vr: '',
        date1: '',
        date2: '',
        iAdminId: '',
    });

    const [defaultValue, setDefaultValue] = useState({
        ma: '0,',
        di: '0,',
        wo: '0,',
        doo: '0,',
        vr: '0,',
        date1: '',
        date2: '',
        iAdminId: '',
    });

    const [logModalContentType, setLogModalContentType] = useState({
        state: false,
        type: 'dagdelen'
    });

    const extractDetailsPayload = (res) => {
        if (res && res.data) {
            if (res.data && typeof res.data === 'object' && !Array.isArray(res.data) && res.data.data) {
                return res.data.data;
            }
            if (res.data && typeof res.data === 'object' && !Array.isArray(res.data) && !res.data.data) {
                return res.data;
            }
        }
        return null;
    };

    const extractFiltersArray = (res) => {
        if (!res) return null;
        if (Array.isArray(res)) return res;
        if (Array.isArray(res?.data?.data)) return res.data.data;
        if (Array.isArray(res?.data)) return res.data;
        return null;
    };

    const prefetchPlanscreenFilters = async (rows) => {
        if (!Array.isArray(rows) || rows.length === 0) return;

        const endpoint = getPlanscreenEndpoint();
        const communityDayMap = new Map();

        rows.forEach((row) => {
            const ochtendId = row?.data?.Ochtend?.iSubsDateId;
            const middagId = row?.data?.Middag?.iSubsDateId;
            const dayId = ochtendId ?? middagId;
            const communityId =
                row?.data?.Ochtend?.iCommunityId ??
                row?.data?.Middag?.iCommunityId ??
                row?.iCommunityId;

            if (!communityId || !dayId) return;
            const communityKey = String(communityId).trim();
            const dayKey = String(dayId).trim();
            if (!communityKey || !dayKey) return;
            if (!communityDayMap.has(communityKey)) {
                communityDayMap.set(communityKey, dayKey);
            }
        });

        for (const [communityId, dayId] of communityDayMap.entries()) {
            if (!communityId || !dayId) continue;
            if (prefetchedCommunityIdsRef.current.has(communityId)) continue;
            try {
                const detailsQueryKey = ["planscreen", "details", communityId, endpoint];
                if (queryClient.getQueryData(detailsQueryKey)) {
                    prefetchedCommunityIdsRef.current.add(communityId);
                    continue;
                }

                prefetchedCommunityIdsRef.current.add(communityId);
                prefetchedDayIdsRef.current.add(dayId);
                const detailsRes = await queryClient.prefetchQuery({
                    queryKey: detailsQueryKey,
                    queryFn: () =>
                        PlanscreenService.getDetails(`${dayId}?page=1&pageSize=150`).then((res) =>
                            extractDetailsPayload(res)

                        ),
                    staleTime: 30 * 60 * 1000,
                });
            
                const payload = detailsRes;
                if (!payload) continue;

                const excludeWwz = payload?.excludeWwz ?? "0";
                const resolvedCommunityId = payload?.community?.id ?? communityId ?? "0";
                const contracts = Array.isArray(payload?.contracts) ? payload.contracts : [];

                for (const contract of contracts) {
                    if (!contract || contract.id <= 0) continue;

                    const filtersQueryKey = [
                        "planscreen",
                        "filters",
                        resolvedCommunityId,
                        contract.id,
                    ];

                    if (getCachedFiltersForContract(resolvedCommunityId, contract.id)) continue;
                    if (queryClient.getQueryData(filtersQueryKey)) continue;

                    try {
                        const filtersData = await queryClient.prefetchQuery({
                            queryKey: filtersQueryKey,
                            queryFn: () =>
                                PlanscreenService.getFilters(
                                    contract.id,
                                    excludeWwz,
                                    resolvedCommunityId
                                ).then((res) => extractFiltersArray(res)),
                            staleTime: 30 * 60 * 1000,
                        });

                        if (Array.isArray(filtersData)) {
                            setCachedFiltersForContract(resolvedCommunityId, contract.id, filtersData);
                        }
                    } catch (e) {
                        console.error(
                            `[ERROR] Planscreen filter prefetch failed for contract ${contract.id}:`,
                            e
                        );
                    }
                }
            } catch (e) {
                console.error(`[ERROR] Planscreen details prefetch failed for day ${dayId}:`, e);
            }
        }
    };

    const getKey = (pageIndex, previousPageData) => {
        if (!substitutionId) return null;

        if (previousPageData && previousPageData.data?.pageCount <= pageIndex) {
            return null;
        }

        return `${substitutionId}?page=${pageIndex + 1}&pageSize=${pageSize}`;
    };

    const fetcher = async (url) => {
        const res = await VerzoekenService.getRequestById(url);
        return res.data;
    };
    const { data: pages, size, setSize, mutate, isLoading } = useSWRInfinite(
        getKey,
        fetcher
    );

    const list = useMemo(() => {
        if (!pages) return [];

        return pages.flatMap(
            page => page?.data?.list || []
        );
    }, [pages]);

    const firstPageData = pages?.[0];

    useEffect(() => {
        if (
            firstPageData?.error === "invalid_link"
        ) {
            navigate("/no-page-found");
        }
    }, [firstPageData]);

    useEffect(() => {
        const responseData = pages?.[0];
        if (!responseData) return;
        if (firstLoad.current) {
            setRecipientsLists(responseData.recipientsList);
            firstLoad.current = false;
        }
    }, [pages]);

    useEffect(() => {
        const responseData = pages?.[0]?.data;

        if (!responseData) return;

        setSelectedDate(
            moment(responseData.vMelderReminder)
                .format("DD-MM-YYYY")
        );
    }, [pages]);

    useEffect(() => {
        const responseData = pages?.[0]?.data;

        if (!responseData?.list) return;

        prefetchPlanscreenFilters(responseData.list);
    }, [pages]);

    const data = pages?.[0] ? { data: pages[0].data } : null;
    const schoolId = pages?.[0]?.data?.iSchoolId;
    const communityId = pages?.[0]?.data?.iCommunityId;

    const { data: absentResponse } = useSWR(
        schoolId && communityId
            ? ["absent-users", schoolId, communityId]
            : null,
        ([, schoolId, communityId]) =>
            CommonService.absentData(schoolId, communityId)
    );
    const absentsData = useMemo(() => {
        const userData = Array.isArray(absentResponse?.data?.data)
            ? [...absentResponse.data.data]
            : [];

        userData.forEach(element => {
            element.name = TextLimit.AfwezigeLimitOptionOne(
                element.vFirstName,
                element.vMiddleName,
                element.vLastName
            );
        });

        return userData;
    }, [absentResponse]);

    const {
        data: DayPartsResponse,
    } = useDeleteDayPart(dayPartId);


    useEffect(() => {
        if (!DayPartsResponse) return;
        // toast.success("Dagdelen succesvol verwijderd.");
        mutate();
    }, [DayPartsResponse]);

    const deleteDates = (id) => {
        setShowModal(false);
        setDayPartId(id);
    };

    useEffect(() => {
        const newList = data?.data?.recipientsList;

        if (!firstLoad.current && newList) {
            const merged = { ...prevRecipientsRef.current };

            Object.keys(newList).forEach(key => {
                const newValue = newList[key];
                const prevValue = merged[key];

                // Deduplicate arrays based on 'id'
                if (Array.isArray(prevValue) && Array.isArray(newValue)) {
                    const allItems = [...prevValue, ...newValue];

                    const deduped = [];
                    const seenIds = new Set();

                    for (const item of allItems) {
                        if (item && item.id && !seenIds.has(item.id)) {
                            deduped.push(item);
                            seenIds.add(item.id);
                        }
                    }

                    merged[key] = deduped;
                }
                // If both are objects → replace
                else if (
                    typeof prevValue === "object" &&
                    typeof newValue === "object" &&
                    !Array.isArray(prevValue) &&
                    !Array.isArray(newValue)
                ) {
                    merged[key] = { ...newValue };
                }
                // If key is new or type mismatch → just set
                else {
                    merged[key] = newValue;
                }
            });


            setRecipientsLists(merged);
            prevRecipientsRef.current = merged;
        }
    }, [data?.data?.recipientsList]);

    const initialized = useRef(false);

    useEffect(() => {
        if (!data?.data) return;

        if (initialized.current) return;

        initialized.current = true;

        setSelectedStatus(
            data.data.geparkDateStatus === "Y"
                ? "Geparkeerd"
                : data.data.eStatus
        );
    }, [substitutionId, data]);

    const updateModalContentType = (state, type) => {
        setLogModalContentType({
            state,
            type
        });
    }

    const updateStatus = (iSubsDateId, eSubStatus) => {
        let formData = new FormData();
        formData.append('iSubstitutionId', substitutionId);
        formData.append('iSubsDateId', iSubsDateId);
        formData.append('eSubStatus', eSubStatus);
        formData.append('user', "coordinator")
        updateDayPartStatus({
            data: formData
        }).then((response) => {
            if (response.status === 200 || response.status) {

            }
        })
            .catch((error) => console.log("catch error:", error));
    }

    const updateWtf = (iSubsDateId, wtf) => {
        let formData = new FormData();
        formData.append('iSubstitutionId', substitutionId);
        formData.append('iSubsDateId', iSubsDateId);
        formData.append('wtf', wtf);

        updateWtfMutation({
            data: formData,
        }).then((response) => {
            if (response.status === 200) {

            }
        })
            .catch((error) => console.log("catch error:", error));
    }


    const hasMore =
        pages &&
        size < (pages?.[0]?.data?.pageCount || 0);

    useEffect(() => {
        setIsPaginating(false);
    }, [pages]);

    useEffect(() => {
        if (pages?.[0]?.data?.eOpmerkingen !== undefined) {
            setSchoolMarking(pages[0].data.eOpmerkingen);
        }
    }, [pages]);

    useEffect(() => {
        if (data?.data?.eMarkeren !== undefined) {
            setUserMarking(data.data.eMarkeren);
        }
    }, [pages]);



    useEffect(() => {
        setUserMarking(data?.data?.eMarkeren);
    }, [pages]);

    const lastItemRefForRequestTable = useCallback(
        (node) => {
            if (observer.current) observer.current.disconnect();

            observer.current = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting && hasMore) {

                        setIsPaginating(true);
                        setSize(prev => prev + 1);
                    }
                },
                {
                    root: null,
                    rootMargin: '0px 0px 600px 0px',
                    threshold: 0,
                }
            );

            if (node) observer.current.observe(node);
        },
        [hasMore]
    );


    const changeStatus = (iSubsDateId, eSubStatus, userData = null) => {
        Object.keys(data.data?.list).map(function (key, index) {
            if (data.data.list[key]['data'].Ochtend && data.data.list[key]['data'].Ochtend.iSubsDateId == iSubsDateId) {
                data.data.list[key]['data'].Ochtend.eSubStatus = eSubStatus
            }
            else {
                if (data.data.list[key]['data'].Middag && data.data.list[key]['data'].Middag.iSubsDateId == iSubsDateId)
                    data.data.list[key]['data'].Middag.eSubStatus = eSubStatus
            }
        })
        mutate(currentPages => {
            if (!currentPages) return currentPages;

            const updatedPages = structuredClone(currentPages);

            updatedPages.forEach(page => {
                page.data.list.forEach(item => {
                    if (
                        item.data?.Ochtend?.iSubsDateId == iSubsDateId
                    ) {
                        item.data.Ochtend.eSubStatus = eSubStatus;
                    }

                    if (
                        item.data?.Middag?.iSubsDateId == iSubsDateId
                    ) {
                        item.data.Middag.eSubStatus = eSubStatus;
                    }
                });
            });

            return updatedPages;
        }, false);

        updateStatus(iSubsDateId, eSubStatus)
        setValue(value => value + 1);
    }

    const confirmDelete = (value, type) => {

        if (type === 'dagdeel') {
            setDeleteModalData({ type: 'dagdeel', data: { iSubsDateId: value?.iSubsDateId } });
        } else {
            setDeleteModalData({ type: 'vervanger', data: { iSubstitutionId: value?.iSubstitutionId, iSubsDateId: value?.iSubsDateId, iSubstitutorAdminId: value?.iSubstitutorAdminId } });
        }
        setShowModal(true);
    }
    const sanitizeMessage = (text = "") => {
        return text
            .replace(/\[([^\]]+)\]/g, '$1')
            .replace(/@@(\d+)\|([^@]+)@@/g, '@$2')
            .replace(/\n+/g, ' ')
            .replace(/(@[^\s]+)\s+@/g, '$1 @')
            .replace(/^\s+|\s+$/g, '')
            .replace(/\s+$/, '')
            .trim();
    };

    const sendMessage = (e) => {
        e.preventDefault()
        setIsDisabled(true);

        if (message.trim().length) {
            const cleanedText = sanitizeMessage(message);
            const msg = {
                text: cleanedText,
                substitution: substitutionId,
                user: "coordinator"
            }

            saveMessage({
                data: msg
            }).then((response) => {
                if (response.status === "success") {
                    setIsOpen(false);
                    setComments([...comments, response.message])
                    setMessage("")
                }
            })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() => {
                    setIsDisabled(false);
                });
        } else {
            setIsEmpty(true)
            setIsDisabled(false);
        }
    }

    const switchIsChecked = (type) => {
        if (isChecked == false) {
            setIsChecked(true);
        } else {
            setIsChecked(false);
        }
        getArchivedMessages(type);
    }
    const displayDate =
        selectedDate && selectedDate !== "Invalid date"
            ? selectedDate
            : "";


    const saveShiftData = (value, type) => {
        if (type === "eOpmerkingen") {
            setSchoolMarking(value);
        }
        if (type === "eMarkeren") {

            setUserMarking(value);
        }

        let formData = new FormData();
        if (value === "Geparkeerd") {
            formData.append('iSubstitutionId', substitutionId);
            formData.append('value', value);
            formData.append('type', type);
            formData.append('dParkdate', data.data.dParkdate);
        } else {
            formData.append('iSubstitutionId', substitutionId);
            formData.append('value', value);
            formData.append('type', type);
        }

        trigger({
            method: "post",
            data: formData,
        })
            .then((response) => {
                if (value === "Behandeld" && response?.substIngeplandStatusCount != null) {
                    setShowSweetAlert(true);
                } else if (response.status === true) {
                    setShow(false);
                    setUserDropdownShow(false);
                    setHomeDropdownShow(false);

                    if (value == "Geparkeerd") {
                    }
                    else {
                        mutate();
                    }
                }
            })
            .catch((error) => {
                console.log("catch error:", error);
            });
    };



    const handleStatusChange = (e) => {
        const selected = e.target.value;
        setSelectedStatus(selected);
        if (selected === 'Geparkeerd') {
            setIsDatePickerOpen(true);
        } else {
            setIsDatePickerOpen(false);
        }
        saveShiftData(selected, 'eStatus');
    };

    const dropDownIsOpen = () => {
        setMenuShow(false);
        setUserDropdownShow(false);
        setHomeDropdownShow(false);
        if (show === false) {
            setShow(true);
        } else {
            setShow(false);
        }
    }

    const menuIsOpen = () => {
        setShow(false);
        setUserDropdownShow(false);
        setHomeDropdownShow(false);
        if (menuShow === false) {
            setMenuShow(true);
        } else {
            setMenuShow(false);
        }
    }

    const homeIsOpen = () => {
        setMenuShow(false);
        setShow(false);
        setUserDropdownShow(false);
        if (homeDropdownShow === false) {
            setHomeDropdownShow(true);
        } else {
            setHomeDropdownShow(false);
        }
    }

    const userIsOpen = () => {
        setMenuShow(false);
        setShow(false);
        setHomeDropdownShow(false);
        if (userDropdownShow === false) {
            setUserDropdownShow(true);
        } else {
            setUserDropdownShow(false);
        }
    }

    const validationSchema = Yup.object().shape({
        ma: Yup.number()
            .transform((_, value) => {
                if (value.includes('.')) {
                    return null;
                }
                return +value.replace(/,/, '.');
            })
            .test(
                'at-least-one-field',
                'Ten minste één veld moet een waarde hebben',
                function (value) {
                    const { wo, di, vr, doo } = this.parent || {};
                    return (value && value !== '') || (wo && wo !== '') || (di && di !== '') || (vr && vr !== '') || (doo && doo !== '');
                }
            ),

        di: Yup.string().test(
            'at-least-one-field',
            'Ten minste één veld moet een waarde hebben',
            function (value) {
                const { ma, wo, vr, doo } = this.parent || {};
                return (value && value !== '') || (ma && ma !== '') || (wo && wo !== '') || (vr && vr !== '') || (doo && doo !== '');
            }
        ),

        wo: Yup.string().test(
            'at-least-one-field',
            'Ten minste één veld moet een waarde hebben',
            function (value) {
                const { ma, di, vr, doo } = this.parent || {};
                return (value && value !== '') || (ma && ma !== '') || (di && di !== '') || (vr && vr !== '') || (doo && doo !== '');
            }
        ),

        doo: Yup.string().test(
            'at-least-one-field',
            'Ten minste één veld moet een waarde hebben',
            function (value) {
                const { ma, di, vr, wo } = this.parent || {};
                return (value && value !== '') || (ma && ma !== '') || (di && di !== '') || (wo && wo !== '') || (vr && vr !== '');
            }
        ),

        vr: Yup.string().test(
            'at-least-one-field',
            'Ten minste één veld moet een waarde hebben',
            function (value) {
                const { ma, di, wo, doo } = this.parent || {};
                return (value && value !== '') || (ma && ma !== '') || (di && di !== '') || (wo && wo !== '') || (doo && doo !== '');
            }
        ),
        date1: Yup.string().required("veld is verplicht"),
        date2: Yup.string().required("veld is verplicht"),
        iAdminId: Yup.string().required("veld is verplicht"),
    });



    const resetFormValues = () => {
        setFormDataState({
            ...formDataState,
            ma: '',
            di: '',
            wo: '',
            doo: '',
            vr: '',
            date1: '',
            date2: '',
            iAdminId: '',
        });
        setDefaultValue({
            ...formDataState,
            ma: '0,',
            di: '0,',
            wo: '0,',
            doo: '0,',
            vr: '0,',
            date1: '',
            date2: '',
            iAdminId: '',
        });
    }

    const handleSubmit = () => {
        let formData = new FormData();
        formData.append('ma', defaultValue.ma);
        formData.append('di', defaultValue.di);
        formData.append('wo', defaultValue.wo);
        formData.append('doo', defaultValue.doo);
        formData.append('vr', defaultValue.vr);
        formData.append('date1', defaultValue.date1);
        formData.append('date2', defaultValue.date2);
        formData.append('iSubstitutionId', substitutionId);
        formData.append('iAdminId', defaultValue.iAdminId);
        formData.append('id', longContractId);

        if (type === 'update') {
            updateLongContractMutation({
                data: formData
            }).then((response) => {
                if (response.status === true) {
                    setType('');
                    toast["success"]("Het lange contract is succesvol bijgewerkt.")
                    resetFormValues();
                    setIsLongContractOpen(false);
                    mutate();
                } else if (response.status === 304) {
                    setIsLongContractOpen(false);
                    toast["warning"]("datum bestaat al!")
                    resetFormValues();
                }
            })
                .catch((error) => console.log("catch error:", error));
        } else {
            saveLongContractMutation({
                data: formData
            }).then((response) => {
                if (response.status === true) {
                    toast["success"]("Het lange contract is succesvol opgeslagen.")
                    resetFormValues();
                    setIsLongContractOpen(false);
                    mutate();
                } else if (response.status === 304) {
                    setIsLongContractOpen(false);
                    toast["warning"]("datum bestaat al!")
                    resetFormValues();
                }
            })
                .catch((error) => console.log("catch error:", error));
        }

    }

    useEffect(() => {
        if (longContractDetails?.status) {
            setFormDataState({
                ma: longContractDetails.data.iWtfMa,
                di: longContractDetails.data.iWtfDi,
                wo: longContractDetails.data.iWtfWo,
                doo: longContractDetails.data.iWtfDo,
                vr: longContractDetails.data.iWtfVr,
                date1: longContractDetails.data.dDateBegin,
                date2: longContractDetails.data.dDateEnd,
                iAdminId: longContractDetails.data.iAdminId,
            });

            setDefaultValue({
                ma: longContractDetails.data.iWtfMa,
                di: longContractDetails.data.iWtfDi,
                wo: longContractDetails.data.iWtfWo,
                doo: longContractDetails.data.iWtfDo,
                vr: longContractDetails.data.iWtfVr,
                date1: longContractDetails.data.dDateBegin,
                date2: longContractDetails.data.dDateEnd,
                iAdminId: longContractDetails.data.iAdminId,
            });

            setIsLongContractOpen(true);
        }
    }, [longContractDetails]);

    const userIconSwitch = (value) => {
        switch (value) {
            case 'No':
                return <TeacherRead />;
            case 'Yes':
                return <Teacher />;
            case 'Yes1':
                return <Teachershow />;
            default:
                return '';
        }
    }

    const homeIconSwitch = (value) => {
        switch (value) {
            case 'No':
                return <RaedSchool />;
            case 'Yes':
                return <Home />;
            case 'Yes1':
                return <ShowSchool />;
            default:
                return '';
        }
    }

    const bulkShiftInformation = () => {
        VerzoekenService.getBulkShiftDetailsById(substitutionId).then((response) => {
            if (response.data.status === true) {
                setBulkRequestIsOpen(true)
                setBulkShiftData(response.data.data);
                setCheckedList(Object.fromEntries(Object.entries(response.data.data.dayparts).filter(([key, value]) => value === 0)));

                let currentState = '';
                let newStatus = '';
                if (response.data.data.substList.length === 0) {
                    currentState = 'Openstaand';
                    newStatus = 'Verwijderen';
                } else {
                    currentState = '-1';
                    newStatus = '-1';
                }

                setBulkFormData({
                    start: response.data.data.startDate,
                    end: response.data.data.endDate,
                    substitutor: '-1',
                    current_state: currentState,
                    newDayType: '-1',
                    newWtfType: '-1',
                    newStatus: newStatus,
                    newInform: 'yes',
                    items: Object.fromEntries(Object.entries(response.data.data.dayparts).filter(([key, value]) => value === 0)),
                });
            }
        })
            .catch((error) => console.log("catch error:", error));
    }

    const handleDateChange = (date) => {

        const formattedDate = moment(date).format('YYYY-MM-DD');
        saveShiftData(formattedDate, 'dParkDate');
        setIsDatePickerOpen(false);
    };
    const handleClear = () => {
        setSelectedDate(null);
        setIsMelderDatePicker(false);
        melderReminder(value, type)
    };
    const handleMelderDatePicker = (e) => {
        if (e) e.stopPropagation();
        setIsMelderDatePicker((prevState) => !prevState);
    };




    const deleteUser = (payload) => {
        removeUserMutation({
            data: payload
        }).then((response) => {

            if (response.status == true) {
                mutate();

                const emailSmsRecipients = {
                    id: payload.iSubstitutorAdminId,
                    name: payload.name || "Onbekende gebruiker",
                    iSubstitutionId: payload.iSubstitutionId,
                    iSubDateId: payload.iSubDateId,
                };

                setEmailAndSmsRecipients((prev) => {
                    const exists = prev.some((item) => item.id === emailSmsRecipients.id);
                    if (!exists) {
                        return [...prev, emailSmsRecipients];
                    }
                    return [...prev];
                });
            } else {
                toast["error"]("Gebruiker konden niet worden verwijderd.");
            }
        })
            .catch((error) => {
                console.log("catch error:", error);
                toast["error"]("Gebruiker konden niet worden verwijderd.");
            }).finally(() => {
                setShowModal(false);
            });

    }
    const handleSchedulerNoteChange = (newValue, mentions) => {
        setMessage(newValue);

        setFormDataState(prev => ({
            ...prev,
            schedulerNote: value,
            mentions
        }));
    };
    const melderReminder = (value, type) => {
        const payload = {

            iSubstitutionId: Number(substitutionId),
            vMelderReminder: value

        }
        melderReminderMutation({
            data: payload
        }).then((response) => {

            if (response.status === true) {
                mutate();
            }
        })
            .catch((error) => {
                console.log('catch error', error)
            })
    }
    const handleDatepickerToggle = () => {
        setIsDatePickerOpen(false);
    };



    return (
        <>
            {
                isLoading ? (
                    <Loader type="ball-grid-pulse" className={'mb-3 d-flex mx-auto justify-content-center'} />
                ) : (
                    <div className="chat-layout-wrapper">
                        <div className="app-inner-layout chat-layout" >
                            <PageHeading />
                            <div className="app-inner-layout__wrapper">
                                <Card className="app-inner-layout__content ">
                                    <Row className="mx-0">
                                        {!pages ? <Col md={window.innerWidth < 1500 ? "12" : "10"} sm="12" className="pe-xxl-5">
                                            {<TransitionOnLoad><Card className="main-card mb-3 ">
                                                <CardBody className="p-3 d-flex justify-content-center ">
                                                    <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
                                                </CardBody>
                                            </Card></TransitionOnLoad>
                                            }
                                        </Col>
                                            : <Col md={window.innerWidth < 1500 ? "12" : "10"} sm="12" className="pe-xxl-5">
                                                <Details data={data?.data} getRequests={mutate} getLongContractDetails={getLongContractDetails} setType={setType} />
                                                <Card className="main-card mb-3 ">
                                                    <CardBody className="p-2 ">
                                                        <div className="request-list-scroll">
                                                            <RequestList emailSmsRecipients={emailSmsRecipients} setEmailAndSmsRecipients={setEmailAndSmsRecipients} showWTFValue={showWTFValue} dayTypeList={data.data?.dayType} list={list} confirmDelete={confirmDelete} updateStatus={updateStatus}
                                                                changeStatus={changeStatus} updateWtf={updateWtf} getRequests={mutate} setStatusCount={setStatusCount}
                                                                statusCount={statusCount} lastItemRef={lastItemRefForRequestTable} />
                                                        </div>
                                                        {isPaginating && (
                                                            <div className="text-center mt-3 d-flex align-items-center justify-content-center gap-2">
                                                                <Spinner size="sm" color="primary" />
                                                                <span>Meer gegevens weergeven</span>
                                                            </div>
                                                        )}
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        }

                                        <Col md={window.innerWidth < 1500 ? "12" : "2"} sm="12">
                                            <Chat setIsOpen={setIsOpen} comments={comments} list={list} sanitizeMessage={sanitizeMessage} getArchivedMessages={getArchivedMessages}
                                                handleSchedulerNoteChange={handleSchedulerNoteChange} absentData={absentsData} getRequests={mutate} nameList={data?.data?.vervangerNameList} refreshArchivedMessages={mutateArchivedMessages} isChecked={isChecked} setIsChecked={setIsChecked} switchIsChecked={switchIsChecked} />
                                        </Col>
                                    </Row>
                                </Card>

                            </div>
                        </div>
                        <div className="chat-layout-footer">
                            <CardFooter className="d-block text-center d-flex chat-layout-footer__inner">
                                <div className="flex-grow-1 d-flex justify-content-start">

                                    <UncontrolledButtonDropdown isOpen={menuShow}>
                                        <DropdownToggle color="link" className="p-0">

                                            <Tippy content="Wijzig verzoek" placement="top">
                                                <span>
                                                    <Button
                                                        className="d-flex align-items-center btn-color-style markeren-btn mb-2 me-2"
                                                        size="sm"
                                                        outline
                                                        color="primary"
                                                        onClick={() => menuIsOpen()}
                                                    >
                                                        <EditPen />
                                                    </Button>
                                                </span>
                                            </Tippy>
                                        </DropdownToggle>
                                        <DropdownMenu className={"rm-pointers dropdown-menu-lg menu-dropdown"}>
                                            <Nav vertical>
                                                <NavLink onClick={() => {
                                                    setIsLongContractOpen(true);
                                                    setMenuShow(false)
                                                }
                                                }>
                                                    Lang verzoek toevoegen
                                                </NavLink>

                                                <NavLink className="navlink-border" onClick={() => navigate(`/verzoeken/overzicht/${substitutionId}/dagdelen-toevoegen`)}>
                                                    Dagdeel toevoegen
                                                </NavLink>

                                                <NavLink className="navlink-border" onClick={() => {
                                                    setMenuShow(false)
                                                    setEditRequestIsOpen(true)
                                                }
                                                }>
                                                    Wijzig algemene gegevens
                                                </NavLink>

                                                <NavLink className="navlink-border" onClick={() => {
                                                    setMenuShow(false)
                                                    bulkShiftInformation();
                                                }}>
                                                    Wijzig dagdelen
                                                </NavLink>
                                            </Nav>
                                        </DropdownMenu>
                                    </UncontrolledButtonDropdown>

                                    {

                                        <UncontrolledButtonDropdown isOpen={homeDropdownShow}>
                                            <Tippy content="Schoolmarkering" placement="top">
                                                <span>
                                                    <DropdownToggle color="link" className="p-0">
                                                        <Button
                                                            className="d-flex align-items-center btn-color-style markeren-btn mb-2 me-2"
                                                            // style={{ height: "33px", minHeight: "33px" }}
                                                            size="sm"
                                                            outline
                                                            color="primary"
                                                            onClick={() => homeIsOpen()}
                                                        >
                                                            {homeIconSwitch(schoolMarking)}
                                                        </Button>
                                                    </DropdownToggle>
                                                </span>
                                            </Tippy>
                                            <DropdownMenu className={"rm-pointers dropdown-menu-lg  verzoeken-dropdown"} >

                                                <Nav vertical>
                                                    <NavLink className="link-gap" onClick={() => saveShiftData('No', 'eOpmerkingen')}>
                                                        <span><RaedSchool /></span>
                                                        <span>Verbergen </span>
                                                    </NavLink>

                                                    <NavLink className="link-gap navlink-border " onClick={() => saveShiftData('Yes', 'eOpmerkingen')}>
                                                        <span><Home /></span>
                                                        <span>Tonen</span>
                                                    </NavLink>

                                                    <NavLink className="link-gap navlink-border " onClick={() => saveShiftData('Yes1', 'eOpmerkingen')}>
                                                        <span><ShowSchool /></span>
                                                        <span >Gelezen</span>
                                                    </NavLink>
                                                </Nav>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                    }

                                    {

                                        <UncontrolledButtonDropdown isOpen={userDropdownShow}>
                                            <Tippy content="Vervangermarkering" placement="top">
                                                <span>
                                                    <DropdownToggle color="link" className="p-0">
                                                        <Button className="d-flex align-items-center markeren-btn btn-color-style mb-2 me-2" size="sm" outline color="primary" onClick={() => userIsOpen()}>
                                                            {userIconSwitch(userMarking)}
                                                        </Button>
                                                    </DropdownToggle>
                                                </span>
                                            </Tippy>
                                            <DropdownMenu className={"rm-pointers dropdown-menu-lg  verzoeken-dropdown"} >

                                                <Nav vertical>

                                                    <NavLink className="link-gap navlink-border" onClick={() => saveShiftData('No', 'eMarkeren')}>
                                                        <span><TeacherRead /></span>
                                                        <span>Verbergen</span>
                                                    </NavLink>

                                                    <NavLink className="link-gap navlink-border " onClick={() => saveShiftData('Yes', 'eMarkeren')}>
                                                        <span><Teacher /></span>
                                                        <span>Tonen</span>
                                                    </NavLink>

                                                    <NavLink className="link-gap navlink-border " onClick={() => saveShiftData('Yes1', 'eMarkeren')}>
                                                        <span><Teachershow /></span>
                                                        <span >Gelezen</span>
                                                    </NavLink>
                                                </Nav>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                    }

                                    <UncontrolledButtonDropdown isOpen={show}>
                                        <DropdownToggle color="link" className="p-0">
                                            <Tippy content="Kleurmarkering" placement="top">
                                                <span>
                                                    <Button className="d-flex align-items-center btn-color-style markeren-btn mb-2 me-2" size="sm" outline color="primary" onClick={() => dropDownIsOpen()}>
                                                        <GrrayCircle fill={data?.data !== undefined && data?.data?.markereColor !== null ? data?.data?.markereColor : '#878EA6'} />
                                                    </Button>
                                                </span>
                                            </Tippy>
                                        </DropdownToggle>
                                        <DropdownMenu className={"rm-pointers dropdown-menu-lg verzoeken-dropdown"} >
                                            <span className="markeren-title">Markeren</span>
                                            <Nav vertical>

                                                <NavLink className="link-gap" onClick={() => saveShiftData('null', 'markereColor')}>
                                                    <span><Grijs /></span>
                                                    <span>Grijs</span>
                                                </NavLink>

                                                <NavLink className="link-gap navlink-border " onClick={() => saveShiftData('#FF0000', 'markereColor')}>
                                                    <span><Rood /></span>
                                                    <span>Rood</span>
                                                </NavLink>

                                                <NavLink className="link-gap navlink-border " onClick={() => saveShiftData('#008000', 'markereColor')}>
                                                    <span><Groen /></span>
                                                    <span >Groen</span>
                                                </NavLink>

                                                <NavLink className="link-gap navlink-border " onClick={() => saveShiftData('#800080', 'markereColor')}>
                                                    <span><Paars /></span>
                                                    <span>Paars</span>
                                                </NavLink>

                                                <NavLink className="link-gap navlink-border " onClick={() => saveShiftData('#FFA500', 'markereColor')}>
                                                    <span><Oranje /></span>
                                                    <span>Oranje</span>
                                                </NavLink>

                                            </Nav>
                                        </DropdownMenu>
                                    </UncontrolledButtonDropdown>


                                    <ButtonGroup style={{ height: 'min-content' }} className="me-2 ">
                                        <Tippy content="Herinneringsdatum" placement="top">
                                            <span>
                                                <Button outline className="btn-color-style btn-datepicker rounded d-flex align-items-center  px-2" onClick={handleMelderDatePicker} style={{ padding: "6px" }}>
                                                    <AlarmClock className="me-2 color-svg" />
                                                    <span className="me-2">

                                                        {displayDate || "Selecteer datum"}
                                                    </span>
                                                    {displayDate ? (
                                                        <button onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleClear();
                                                        }} className="border border-0 cross" style={{ background: 'transparent' }}>
                                                            <RxCross1 className="color-svg"  />
                                                        </button>
                                                    ) : null}


                                                </Button>
                                            </span>
                                        </Tippy>
                                        <DatePicker
                                            open={isMelderDatePicker}
                                            locale="nl"
                                            clearButtonTitle="clear"
                                            onChange={(value) => {
                                                melderReminder(moment(value).format('DD-MM-yyyy'), 'dParkDate')
                                                handleMelderDatePicker()
                                            }
                                            }
                                            popperPlacement="bottom-end"
                                            className="hide-datepicker display-none"
                                            minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                        />

                                    </ButtonGroup>

                                    <Col md="1" className="me-2 footer-option">
                                        <div className=" selectBy p-0   d-flex">
                                            <select className="form-select select-arrow-style"
                                            //  style={{ height: '37px' }} 
                                             onChange={handleStatusChange} value={selectedStatus || ''}>
                                                <option value="">Selecteren</option>
                                                <option value='Openstaand' >Openstaand</option>
                                                <option value='Behandeld'>Behandeld</option>
                                                <option value='Afgesloten'>Afgesloten</option>

                                                <option value="Geparkeerd" onClick={handleDatepickerToggle}>
                                                    Geparkeerd: {
                                                        moment(data?.data?.dParkdate).isValid() && moment(data?.data?.dParkdate).format('YYYY-MM-DD') !== '1971-01-01'
                                                            ? moment(new Date(data?.data?.dParkdate)).format('DD-MM-YYYY')
                                                            : ''
                                                    }
                                                </option>

                                            </select>

                                            {/* {selectedStatus === 'Geparkeerd' && ( */}
                                            <DatePicker
                                                open={isDatePickerOpen}
                                                className="hide-datepicker display-none "
                                                onChange={(value) => {
                                                    handleDateChange(value);
                                                }}
                                                locale="nl"
                                                clearButtonTitle="Clear"
                                                popperPlacement="bottom-end"

                                                minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                            />
                                            {/* )} */}
                                        </div>
                                    </Col>

                                    <Modal isOpen={showSweetAlert} className="modal-centered contract-type-modal feedback-modal-style link-form">
                                        <ModalHeader toggle={() => setShowSweetAlert(false)} className='px-3 mt-4'>
                                            Opmerking
                                        </ModalHeader>

                                        <ModalBody className='text-center mt-4 mb-4'>
                                            <p className="contracttype-Modal" style={{ color: 'red', fontWeight: '500' }}>
                                                LET OP: Status wijzigen naar "Behandeld" is niet mogelijk. Alle dagdelen dienen status "Ingepland" te hebben.
                                            </p>
                                        </ModalBody>

                                        <ModalFooter className='justify-content-center pt-3'>
                                            <Button color="link" onClick={() => setShowSweetAlert(false)} className="btn-color-style">
                                                Sluiten
                                            </Button>
                                        </ModalFooter>
                                    </Modal>
                                    <Tippy content="Logboek" placement="top">
                                        <span>
                                            <Button className="d-flex align-items-center btn-color-style me-2 mb-2 px-2 p-2" size="sm" outline color="primary" onClick={() => updateModalContentType(true, "dagdelen")}>
                                                <LogIcon />
                                            </Button>
                                        </span>
                                    </Tippy>

                                    {(data?.data?.list?.some(item =>
                                        item.data?.Ochtend?.iSubstitutorAdminId !== 0
                                    )) ? (
                                        <Col className="d-flex align-items-center mb-2 w-[5%]">
                                            <label className="switch">
                                                <input type="checkbox" onChange={() => setShowWtfValue(!showWTFValue)} />
                                                <span className="slider round"></span>
                                            </label>
                                        </Col>
                                    ) : null}

                                </div>
                                <div>
                                    <Button size="sm" outline className="me-2 btn-color-style footer-btn-styling" color="primary" onClick={() => setIsInformationModalOpen(true)}>
                                        <span className="ms-1">Infomeren</span>
                                        <span>
                                            <span className="blue-circle ">{statusCount}</span>
                                        </span>
                                    </Button>
                                    <Button size="sm" outline className="me-2 btn-color-style footer-btn-styling" color="primary" onClick={() => guardedNavigate("/verzoeken/overzicht")}
                                    >
                                        <Arrow />
                                    </Button>

                                    <DeleteModal showModal={showModal} setShowModal={setShowModal} deleteDates={deleteDates} deleteModalData={deleteModalData} deleteUser={deleteUser} />
                                    {/* opmerking */}
                                    <Modal id={"tooltip"} isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} className="modal-dialog__over feedback-modal-style opmerking-modal-styling ">

                                        <ModalHeader>
                                            <div className="modal-header-styling">
                                                Opmerking
                                            </div>
                                            <div className="cross-icon-color">
                                                <i className="nav-link-icon lnr-cross m-1 cursor-pointer" onClick={() => setIsOpen(false)}> </i>
                                            </div>
                                        </ModalHeader>

                                        <ModalBody className="d-flex bg-white rounded">
                                            <div className="form-style opmerking-input-styling" rows="6">
                                                <MentionInput
                                                    value={message}
                                                    onChange={handleSchedulerNoteChange}
                                                    absentsData={absentsData}
                                                    placeholder={"Typ hier uw opmerking.\nGebruik @ om iemand te vermelden"}
                                                />
                                            </div>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button className="d-flex align-items-center btn-color-style  opslaan-btn" size="sm" outline color="primary" disabled={isDisabled} onClick={sendMessage}>
                                                <Save />
                                                Opslaan
                                            </Button>
                                            <Button className="d-flex align-items-center btn-color-style back-btn" size="sm" outline color="primary" onClick={() => setIsOpen(false)}>
                                                <Small_Arrow />
                                                Terug
                                            </Button>
                                        </ModalFooter>
                                    </Modal>

                                    {/* Log Modal */}
                                    <Modal id={"tooltip"} isOpen={logModalContentType.state} toggle={() => setLogModalContentType(prev => ({ ...prev, state: !prev.state }))} className="modal-dialog__over feedback-modal-style opmerking-modal-styling log-modal">
                                        <Logs id={substitutionId} logType={logModalContentType.type} updateHandler={updateModalContentType} />
                                    </Modal>

                                    <Modal id={"tooltip"} isOpen={isLongContractOpen} toggle={() => setIsLongContractOpen(!isOpen)} className="modal-dialog__over feedback-modal-style opmerking-modal-styling">
                                        <ModalHeader>
                                            <div className="modal-header-styling">
                                                Lang verzoek
                                            </div>
                                            <div className="cross-icon-color">
                                                <i className="nav-link-icon lnr-cross m-1 cursor-pointer" onClick={() => {
                                                    setType('')
                                                    setIsLongContractOpen(false)
                                                    setFormDataState({
                                                        ...formDataState,
                                                        ma: '',
                                                        di: '',
                                                        wo: '',
                                                        doo: '',
                                                        vr: '',
                                                        date1: '',
                                                        date2: '',
                                                        iAdminId: '',
                                                    })
                                                    setDefaultValue({
                                                        ...formDataState,
                                                        ma: '0,',
                                                        di: '0,',
                                                        wo: '0,',
                                                        doo: '0,',
                                                        vr: '0,',
                                                        date1: '',
                                                        date2: '',
                                                        iAdminId: '',
                                                    });
                                                }}> </i>
                                            </div>
                                        </ModalHeader>

                                        <ModalBody className="bg-white rounded">

                                            <Formik
                                                enableReinitialize
                                                initialValues={formDataState}
                                                validationSchema={validationSchema}
                                                onSubmit={
                                                    (values, { setSubmitting }) => handleSubmit(values, setSubmitting)}
                                            >
                                                {({
                                                    values,
                                                    errors,
                                                    touched,
                                                    handleChange,
                                                    handleBlur,
                                                    handleSubmit,
                                                    isSubmitting,
                                                }) => (
                                                    <Form onSubmit={handleSubmit}>
                                                        <>
                                                            <Row>
                                                                <Col sm={6}>
                                                                    <FormGroup>

                                                                        <Label>
                                                                            Begindatum
                                                                        </Label>
                                                                        <DatePicker
                                                                            locale="nl"
                                                                            name="date1"
                                                                            dateFormat="dd-MM-yy"
                                                                            placeholderText={'dd-mm-yy'}
                                                                            className="long-contact"
                                                                            selected={(formDataState.date1 !== '') ? new Date(formDataState.date1) : ''}
                                                                            onChange={(val) => {
                                                                                setFormDataState({ ...formDataState, date1: moment(val).format('yyyy-MM-DD') })
                                                                                setDefaultValue({ ...defaultValue, date1: moment(val).format('yyyy-MM-DD') })
                                                                            }}
                                                                        />
                                                                        <ErrorMessage name="date1" component="small"
                                                                            className="block mt-2 invalid-feedback" />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col sm={6} className="w-full">
                                                                    <FormGroup>
                                                                        <Label>
                                                                            Einddatum
                                                                        </Label>
                                                                        <div className="w-full">
                                                                            <DatePicker
                                                                                locale="nl"
                                                                                name="date2"
                                                                                dateFormat="dd-MM-yy"
                                                                                placeholderText={'dd-mm-yy'}
                                                                                className="long-contact"
                                                                                selected={(formDataState.date2 !== '') ? new Date(formDataState.date2) : ''}
                                                                                onChange={(val) => {
                                                                                    setFormDataState({ ...formDataState, date2: moment(val).format('yyyy-MM-DD') })
                                                                                    setDefaultValue({ ...defaultValue, date2: moment(val).format('yyyy-MM-DD') })
                                                                                }}
                                                                            />
                                                                            <ErrorMessage name="date2" component="small"
                                                                                className="block mt-2 invalid-feedback" />
                                                                        </div>

                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col sm={6}>
                                                                    <FormGroup>
                                                                        <Label>
                                                                            Vervanger
                                                                        </Label>
                                                                        <DropdownList dataKey='iAdminId' textField='name'
                                                                            placeholder="Selecteer een vervanger..."
                                                                            name="iAdminId"
                                                                            onChange={(val) => {
                                                                                setFormDataState({ ...formDataState, iAdminId: val.iAdminId })
                                                                                setDefaultValue({ ...defaultValue, iAdminId: val.iAdminId })
                                                                            }}
                                                                            defaultValue={defaultValue.iAdminId}
                                                                            // value={defaultValue}
                                                                            data={adminList}
                                                                        />
                                                                        <ErrorMessage name="iAdminId" component="small"
                                                                            className="block mt-2 invalid-feedback" />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col sm={6}>
                                                                    <FormGroup>
                                                                        <Label>
                                                                            Wtf MA
                                                                        </Label>
                                                                        <Field
                                                                            className={"form-control"}
                                                                            name="ma"
                                                                            value={defaultValue.ma}
                                                                            onChange={(e) => {
                                                                                setFormDataState({ ...formDataState, ma: e.target.value })
                                                                                setDefaultValue({ ...defaultValue, ma: e.target.value })
                                                                            }}
                                                                        />
                                                                        <ErrorMessage name="ma" component="small"
                                                                            className="block mt-2 invalid-feedback" />
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col sm={6}>
                                                                    <FormGroup>
                                                                        <Label>
                                                                            Wtf DI
                                                                        </Label>
                                                                        <Field
                                                                            value={defaultValue.di}
                                                                            onChange={(e) => {
                                                                                setFormDataState({ ...formDataState, di: e.target.value })
                                                                                setDefaultValue({ ...defaultValue, di: e.target.value })
                                                                            }}
                                                                            className={"form-control"}
                                                                            name="di"
                                                                        />
                                                                        <ErrorMessage name="di" component="small"
                                                                            className="block mt-2 invalid-feedback" />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col sm={6}>
                                                                    <FormGroup>
                                                                        <Label>
                                                                            Wtf WO
                                                                        </Label>
                                                                        <Field
                                                                            value={defaultValue.wo}
                                                                            onChange={(e) => {
                                                                                setFormDataState({ ...formDataState, wo: e.target.value })
                                                                                setDefaultValue({ ...defaultValue, wo: e.target.value })
                                                                            }}
                                                                            className={"form-control"}
                                                                            name="wo"
                                                                        />
                                                                        <ErrorMessage name="wo" component="small"
                                                                            className="block mt-2 invalid-feedback" />
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>

                                                            <Row>
                                                                <Col sm={6}>
                                                                    <FormGroup>
                                                                        <Label>
                                                                            Wtf DO
                                                                        </Label>
                                                                        <Field
                                                                            value={defaultValue.doo}
                                                                            onChange={(e) => {
                                                                                setFormDataState({ ...formDataState, doo: e.target.value })
                                                                                setDefaultValue({ ...defaultValue, doo: e.target.value })
                                                                            }}
                                                                            className={"form-control"}
                                                                            name="doo"
                                                                        />
                                                                        <ErrorMessage name="doo" component="small"
                                                                            className="block mt-2 invalid-feedback" />
                                                                    </FormGroup>
                                                                </Col>

                                                                <Col sm={6}>
                                                                    <FormGroup>
                                                                        <Label>
                                                                            Wtf VR
                                                                        </Label>
                                                                        <Field
                                                                            value={defaultValue.vr}
                                                                            onChange={(e) => {
                                                                                setFormDataState({ ...formDataState, vr: e.target.value })
                                                                                setDefaultValue({ ...defaultValue, vr: e.target.value })
                                                                            }}
                                                                            className={"form-control"}
                                                                            name="vr"
                                                                        />
                                                                        <ErrorMessage name="vr" component="small"
                                                                            className="block mt-2 invalid-feedback" />
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>


                                                            <Button className="d-flex align-items-center btn-color-style  opslaan-btn" size="sm" outline color="primary" type="submit">
                                                                <Save />
                                                                Opslaan
                                                            </Button>

                                                        </>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </ModalBody>
                                    </Modal>
                                    {
                                        data && data?.data &&
                                        <InformationModel emailSmsRecipients={emailSmsRecipients} isOpen={isInformationModalOpen} recipientsLists={recipientsLists}
                                            setIsInformationModalOpen={setIsInformationModalOpen} substitutionId={substitutionId} getRequests={mutate}
                                            coordinatorName={data?.data.coordinatorName} statusCount={statusCount} setStatusCount={setStatusCount} />
                                    }
                                    {editRequestIsOpen && <UpdateRequestModel data={data?.data} isOpen={editRequestIsOpen} setEditRequestIsOpen={setEditRequestIsOpen} getRequests={mutate} />}
                                    <UpdateRequestInBulkModel isOpen={bulkRequestIsOpen} data={bulkShiftData} bulkFormData={bulkFormData} setBulkFormData={setBulkFormData} setBulkRequestIsOpen={setBulkRequestIsOpen} checkedList={checkedList} setCheckedList={setCheckedList} getRequests={mutate} />

                                </div>
                            </CardFooter>
                        </div>
                    </div>
                )
            }
        </>
    )
}





export default Default;
